import { Routes } from '@angular/router';
import { AuthGuard } from '@banyan/commons/guards/auth.guard';
import { AdminLayoutComponent } from '@banyan/features/admin/components/admin-layout/admin-layout.component';
import { adminGuard } from '@banyan/features/admin/guard/admin.guard';
import { articleResolver } from '@banyan/features/articles/article.resolver';
import { editoResolver } from '@banyan/features/edito/edito.resolver';
import { aboutResolver } from '@banyan/features/who-we-are/about.resolver';
import { environment } from '@env/environment';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha-2';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    title: 'home',
    loadComponent: () => import('./features/home/components/home-page/home-page.component').then(m => m.HomePageComponent),
  },
  {
    path: 'login/callback',
    loadComponent: () => import('./features/auth/components/callback-login-page/callback-login-page.component').then(m => m.LoginCallbackComponent),
  },
  {
    path: 'register',
    title: 'register',
    providers: [{ provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKey }],
    loadChildren: () => import('./features/register/register.routes').then(m => m.registerRoutes),
  },
  {
    path: 'contact',
    title: 'contact',
    providers: [{ provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKey }],
    loadChildren: () => import('./features/contact/contact.routes').then(m => m.contactRoutes),
  },
  {
    path: 'terms-of-use',
    title: 'terms',
    loadComponent: () => import('./features/terms-of-use/components/terms-of-use.component').then(m => m.TermsOfUseComponent),
  },
  {
    path: 'who-we-are',
    title: 'who-we-are',
    loadComponent: () => import('./features/who-we-are/components/who-we-are.component').then(m => m.WhoWeAreComponent),
    resolve: { about: aboutResolver },
  },
  {
    path: 'trends-inspirations',
    title: 'trends-inspirations',
    loadComponent: () => import('./features/trends-inspirations/components/trends-inspirations.component').then(m => m.TrendsInspirationsComponent),
  },
  {
    path: 'faq',
    title: 'faq',
    loadComponent: () => import('./features/faq/components/faq.component').then(m => m.FAQComponent),
  },
  {
    path: 'cookie-policy',
    title: 'cookie-policy',
    loadComponent: () => import('./features/cookie-policy/components/cookie-policy.component').then(m => m.CookiePolicyComponent),
  },
  {
    path: 'edito/:id',
    resolve: { edito: editoResolver },
    loadComponent: () => import('./features/edito/components/edito.component').then(m => m.EditoComponent),
  },
  {
    path: 'articles/:id',
    resolve: { article: articleResolver },
    loadComponent: () => import('./features/articles/components/article.component').then(m => m.ArticleComponent),
  },
  {
    path: 'protected',
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./features/protected.routes').then(m => m.protectedRoutes),
  },
  {
    path: 'admin',
    title: 'admin',
    canActivate: [adminGuard],
    runGuardsAndResolvers: 'always',
    component: AdminLayoutComponent,
    loadChildren: () => import('./features/admin/admin.routes').then(m => m.adminRoutes),
  },
  {
    path: 'error',
    title: 'error404',
    loadComponent: () => import('./features/error/components/c404/c404.component').then(m => m.C404Component),
  },
  {
    path: '**',
    redirectTo: '',
  },
];